import { cn } from '@/lib/utils'
import { type TourTitleProps, tourTitleVariants } from './tour-variants'

export function TourTitle({ children, size, className }: TourTitleProps) {
  return <h3 className={cn(tourTitleVariants({ size }), className)}>{children}</h3>
}
